import React, { useState, useEffect, useRef } from 'react';
import { Volume2, VolumeX, Play } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';
import { useLiveBarOffset } from '../hooks/useLiveBarOffset';

const AudioPlayer = ({ onWelcomeClosed }) => {
  const [playlist, setPlaylist] = useState([]);
  const liveBarOffset = useLiveBarOffset();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(false); // SEMPRE começa desmutado
  const [isPlaying, setIsPlaying] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true); // SEMPRE mostra welcome
  const [hasInteracted, setHasInteracted] = useState(false); // SEMPRE false no início
  const audioRef = useRef(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  console.log('🎨 ESTADO ATUAL:', { hasInteracted, isMuted, isPlaying, showWelcome });

  useEffect(() => {
    fetchPlaylist();
  }, []);

  const fetchPlaylist = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/playlist/active`);
      if (response.data && response.data.length > 0) {
        setPlaylist(response.data);
        console.log('✅ Playlist carregada');
      }
    } catch (error) {
      console.error('Erro playlist:', error);
    }
  };

  useEffect(() => {
    if (playlist.length === 0 || !audioRef.current) return;

    const music = playlist[currentIndex];
    audioRef.current.src = `${BACKEND_URL}/api/playlist/stream/${music.id}`;
    audioRef.current.load();
    
    console.log(`🎵 Música ${currentIndex + 1}/${playlist.length}: ${music.title}`);
    
    // Toca se passou do welcome E não está mutado
    if (!showWelcome && !isMuted) {
      audioRef.current.play()
        .then(() => {
          console.log('✅ Tocando!');
          setIsPlaying(true);
        })
        .catch((err) => {
          console.error('Erro ao tocar:', err);
        });
    }
  }, [playlist, currentIndex, showWelcome, isMuted]); // Adicionado isMuted na dependência

  const handleEnterSite = () => {
    console.log('🎵 CLICOU ENTRAR!');
    setShowWelcome(false);
    setHasInteracted(true); // Para de pulsar laranja
    setIsMuted(false);
    
    // Notifica HomePage que modal foi fechado
    if (onWelcomeClosed) {
      setTimeout(() => {
        onWelcomeClosed();
      }, 500); // Pequeno delay para suavizar transição
    }
    
    // Inicia música
    if (audioRef.current) {
      audioRef.current.play()
        .then(() => {
          console.log('✅ Música tocando!');
          setIsPlaying(true);
        })
        .catch(err => console.error('Erro:', err));
    }
  };

  const handleToggle = () => {
    console.log('🎵 CLICOU BOTÃO!');
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    
    // Só marca como interagido se ATIVAR som
    if (!newMuted) {
      console.log('✅ Ativando som - marcando como interagido');
      setHasInteracted(true);
    }
    
    if (audioRef.current) {
      if (newMuted) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play().then(() => setIsPlaying(true)).catch(() => {});
      }
    }
  };

  if (playlist.length === 0) return null;

  return (
    <>
      {/* Overlay de Welcome - Aparece só na primeira vez */}
      {showWelcome && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center animate-fade-in">
          <div className="bg-gradient-to-br from-orange-500 to-purple-600 rounded-3xl shadow-2xl p-8 max-w-md text-center text-white transform hover:scale-105 transition-all">
            <div className="mb-6">
              <h1 className="text-4xl font-bold mb-2">🦊 FOX SELLER</h1>
              <p className="text-lg opacity-90">Bem-vindo!</p>
            </div>
            <Button
              onClick={handleEnterSite}
              size="lg"
              className="bg-white text-purple-600 hover:bg-gray-100 text-xl py-6 px-8 rounded-full shadow-xl"
            >
              <Play className="mr-2 h-6 w-6" />
              Entrar no Site
            </Button>
            <p className="text-sm opacity-75 mt-4">🎵 Com música de fundo</p>
          </div>
        </div>
      )}

      <audio
        ref={audioRef}
        onEnded={() => {
          console.log('🎵 Música terminou, próxima...');
          setCurrentIndex((prev) => (prev + 1) % playlist.length);
        }}
        onPlay={() => {
          console.log('▶️ onPlay');
          setIsPlaying(true);
        }}
        onPause={() => {
          console.log('⏸️ onPause');
          setIsPlaying(false);
        }}
        onError={(e) => {
          console.error('❌ Erro no áudio:', e);
        }}
      />

      <div className="fixed right-6 z-50" style={{ bottom: 96 + liveBarOffset }}>
        <Button
          onClick={handleToggle}
          size="lg"
          className={`rounded-full w-16 h-16 shadow-2xl transition-all ${
            !hasInteracted
              ? 'bg-orange-500 hover:bg-orange-600 animate-pulse'
              : isMuted 
                ? 'bg-gray-500 hover:bg-gray-600' 
                : 'bg-purple-600 hover:bg-purple-700'
          }`}
        >
          {isMuted ? <VolumeX className="h-7 w-7" /> : <Volume2 className="h-7 w-7" />}
        </Button>
      </div>
    </>
  );
};

export default AudioPlayer;
